<template>
  <li
    class="flex items-center justify-between gap-2 px-3 py-2 hover:bg-ghost-white cursor-pointer"
    @mousedown="emit('file:open', file)"
  >
    <div class="flex items-center gap-2 overflow-hidden">
      <icon-base :icon="getFileIcon(file.name)" />
      <span
        class="truncate text-sm text-headline-new max-w-[220px]"
        v-tooltipable.collapsed="formattedSize"
      >
        {{ file.name }}
      </span>
    </div>
    <button
      class="text-label hover:text-error shrink-0"
      @mousedown.stop="deleteFile(file)"
    >
      <icon-base :icon="IconDelete" />
    </button>
  </li>
</template>
<script setup lang="ts">
import { computed } from "vue";

import { getFileIcon } from "@/helpers/files";
import { formatFileSize } from "@/helpers/formatting";

import IconDelete from "@/components/icons/IconDelete.vue";
import IconBase from "@/components/ui/IconBase.vue";

const emit = defineEmits<{ "file:remove": [File]; "file:open": [File] }>();

const { file } = defineProps<{
  file: File;
}>();

const deleteFile = (file: File) => {
  emit("file:remove", file);
};

const formattedSize = computed(() => {
  const bytesToKb = Math.round(file.size / 1024);
  const { unit, size } = formatFileSize(bytesToKb);
  return `${size}${unit}`;
});
</script>
